import { useState } from 'react';

import { Divider } from '@coachhubio/nova-divider';
import { ChevronDownIcon, ChevronRightIcon } from '@coachhubio/nova-icon';
import { useTranslation } from 'react-i18next';

import { HumanLedCoachingMenu } from './HumanLedCoachingMenu';
import { StyledCollapsibleMenu, StyledMenuCollapsibleChevron, StyledMenuCollapsibleHeader, StyledMenuCollapsibleRow } from '../LookerDashboardSideBar.styles';
import { AIMenu } from './AIMenu';
import { useDashboard } from '../context/DashboardContext';
import { AISectionIds, SectionIds } from '../utils/dashboardSideBar';

import { useFlags } from '~/lib/featureFlags';


export const DashboardMenu = ({ currentSectionIndex }: { currentSectionIndex: string }) => {
  const { t } = useTranslation('Dashboard');
  const { enableAiSidebar } = useFlags();
  const { hasHumanLedCoachingPrograms, hasStandaloneAIPrograms } = useDashboard();
  const currentSectionIsAI = Object.values(AISectionIds).includes(currentSectionIndex as AISectionIds);
  const currentSectionIsHumanLedCoaching = Object.values(SectionIds).includes(currentSectionIndex as SectionIds);

  // We'll expand the menu that contains the current section
  const [aiMenuState, setAiMenuState] = useState<boolean>(currentSectionIsAI);
  const [hlcMenuState, setHlcMenuState] = useState<boolean>(currentSectionIsHumanLedCoaching);

  return (
    <>
      {hasHumanLedCoachingPrograms && (
        <>
          <StyledMenuCollapsibleRow
            justifyContent="space-between"
            onClick={(e) => {
              e.stopPropagation();
              setHlcMenuState(!hlcMenuState);
            }}
          >
            <StyledMenuCollapsibleHeader paddingBottom="base">
              {t('section.sidebar-title-hlc')}
            </StyledMenuCollapsibleHeader>
            <StyledMenuCollapsibleChevron Icon={hlcMenuState ? ChevronDownIcon : ChevronRightIcon} size="xs" />
          </StyledMenuCollapsibleRow>
          <StyledCollapsibleMenu isExpanded={hlcMenuState}>
            {<HumanLedCoachingMenu currentSectionIndex={currentSectionIndex} />}
          </StyledCollapsibleMenu>
        </>
      )}
      {enableAiSidebar && hasStandaloneAIPrograms && (
        <>
          <Divider marginBottom="s" />
          <StyledMenuCollapsibleRow
            justifyContent="space-between"
            onClick={(e) => {
              e.stopPropagation();
              setAiMenuState(!aiMenuState);
            }}
          >
            <StyledMenuCollapsibleHeader paddingBottom="base">
              {t('section.sidebar-title-ai')}
            </StyledMenuCollapsibleHeader>
            <StyledMenuCollapsibleChevron Icon={aiMenuState ? ChevronDownIcon : ChevronRightIcon} size="xs" />
          </StyledMenuCollapsibleRow>
          <StyledCollapsibleMenu isExpanded={aiMenuState}>
            {<AIMenu currentSectionIndex={currentSectionIndex} />}
          </StyledCollapsibleMenu>
        </>
      )}
    </>
  );
};
